// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--FWIiv","content-wrapper":"_9e1425b4d3--content-wrapper--SzAhu","button-wrapper":"_9e1425b4d3--button-wrapper--ET8Ro"};